/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { NearbyRegionSectionNearbyRanking } from './NearbyRegionSectionNearbyRanking';
import {
    NearbyRegionSectionNearbyRankingFromJSON,
    NearbyRegionSectionNearbyRankingFromJSONTyped,
    NearbyRegionSectionNearbyRankingToJSON,
} from './NearbyRegionSectionNearbyRanking';
import type { SocialCapitalRegion } from './SocialCapitalRegion';
import {
    SocialCapitalRegionFromJSON,
    SocialCapitalRegionFromJSONTyped,
    SocialCapitalRegionToJSON,
} from './SocialCapitalRegion';

/**
 * 
 * @export
 * @interface SocialCapitalNearbyRegionSection
 */
export interface SocialCapitalNearbyRegionSection {
    /**
     * 
     * @type {string}
     * @memberof SocialCapitalNearbyRegionSection
     */
    targetUri: string;
    /**
     * 
     * @type {SocialCapitalRegion}
     * @memberof SocialCapitalNearbyRegionSection
     */
    targetRegion: SocialCapitalRegion;
    /**
     * 
     * @type {NearbyRegionSectionNearbyRanking}
     * @memberof SocialCapitalNearbyRegionSection
     */
    nearbyRanking?: NearbyRegionSectionNearbyRanking;
    /**
     * 
     * @type {number}
     * @memberof SocialCapitalNearbyRegionSection
     */
    socialCapitalJoinedPoint: number;
}

/**
 * Check if a given object implements the SocialCapitalNearbyRegionSection interface.
 */
export function instanceOfSocialCapitalNearbyRegionSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "targetUri" in value;
    isInstance = isInstance && "targetRegion" in value;
    isInstance = isInstance && "socialCapitalJoinedPoint" in value;

    return isInstance;
}

export function SocialCapitalNearbyRegionSectionFromJSON(json: any): SocialCapitalNearbyRegionSection {
    return SocialCapitalNearbyRegionSectionFromJSONTyped(json, false);
}

export function SocialCapitalNearbyRegionSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialCapitalNearbyRegionSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetUri': json['target_uri'],
        'targetRegion': SocialCapitalRegionFromJSON(json['target_region']),
        'nearbyRanking': !exists(json, 'nearby_ranking') ? undefined : NearbyRegionSectionNearbyRankingFromJSON(json['nearby_ranking']),
        'socialCapitalJoinedPoint': json['social_capital_joined_point'],
    };
}

export function SocialCapitalNearbyRegionSectionToJSON(value?: SocialCapitalNearbyRegionSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_uri': value.targetUri,
        'target_region': SocialCapitalRegionToJSON(value.targetRegion),
        'nearby_ranking': NearbyRegionSectionNearbyRankingToJSON(value.nearbyRanking),
        'social_capital_joined_point': value.socialCapitalJoinedPoint,
    };
}

